import { useEffect } from "react"
import { DEFAULT_COMPANY_STATS, getCompanyStatsAsync } from "../store/slices/companyStats.slice"
import { useEditorSettings } from "./useEditorSettings"
import { useAppDispatch, useAppSelector } from "./useRedux"

export const useCompanyStats = ({ id }: { id: string | undefined }) => {
    const dispatch = useAppDispatch()
    const stats = useAppSelector((state) => (id ? state.companyStats.data[id] : undefined))

    useEffect(() => {
        if (id) dispatch(getCompanyStatsAsync(id))
    }, [dispatch, id])

    return stats ?? DEFAULT_COMPANY_STATS
}

export const useCurrentCompanyStats = () => {
    const { companyId } = useEditorSettings()

    return useAppSelector((state) => state.companyStats.data[companyId] ?? { assets: [] })
}
